export const STORE_KEY = '$_classRoom';
export const SET_LIST_CLASS = "SET_LIST_CLASS"
export const SET_LIST_SUBJECT = "SET_LIST_SUBJECT"
export const GET_LIST_MEMBER = "GET_LIST_MEMBER"
export const GET_LIST_DOCUMENT = "GET_LIST_DOCUMENT"
export const SET_EVENT_CALENDAR = "SET_EVENT_CALENDAR"
export const SET_PARAM_LIST_SCHOOL = "SET_PARAM_LIST_SCHOOL"
export const GET_COURSE_DETAIL = "GET_COURSE_DETAIL"
export const CLASS_SCHOOL_LIST_MEMBER = "CLASS_SCHOOL_LIST_MEMBER"
export const GET_LIST_LESSON_PLAN = "GET_LIST_LESSON_PLAN"
export const LOCAL_SAVE_CHRISTMAS_CARD = "LOCAL_SAVE_CHRISTMAS_CARD"
export const SET_PARAM_DOCCUMENT = "SET_PARAM_DOCCUMENT"
export const GET_LIST_CLASS_DOCCUMENT = "GET_LIST_CLASS_DOCCUMENT"
export const GET_LIST_CLASS_EVENT = "GET_LIST_CLASS_EVENT"
export const GET_DETAIL_EVENT = "GET_DETAIL_EVENT"
export const GET_LIST_CLASS_POSITION = "GET_LIST_CLASS_POSITION"